import { render, staticRenderFns } from "./account-question-set.vue?vue&type=template&id=a74a6304&scoped=true&"
import script from "./account-question-set.vue?vue&type=script&lang=js&"
export * from "./account-question-set.vue?vue&type=script&lang=js&"
import style0 from "./account-question-set.vue?vue&type=style&index=0&id=a74a6304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74a6304",
  null
  
)

export default component.exports